'use client'

import React from 'react'
import Link from 'next/link'
import { Resource } from '@/payload-types'
import Image from 'next/image'
import { isMedia } from '@/lib/utils'
import { Button } from '@/components'

interface CardResourceProps {
  resource: Resource
}

function CardResource({ resource }: Readonly<CardResourceProps>): React.ReactNode {
  const image = resource.image

  let href
  switch (resource.type) {
    case 'case-study':
      href = `/etudes-de-cas/${resource.slug}`
      break
    case 'use-case':
      href = `/cas-usage/${resource.slug}`
  }

  return (
    <div
      key={resource.id}
      className="relative group flex flex-col rounded-xl border overflow-hidden hover:shadow-md transition-shadow"
    >
      {image && isMedia(image) ? (
        <figure className="relative bg-muted aspect-video w-full">
          <Image src={image.url!} alt={image.alt || resource.title} fill objectFit="cover" />
        </figure>
      ) : null}

      <div className="flex flex-col gap-3 p-4 pb-16 flex-1">
        <h3 className="font-semibold text-base leading-tight">{resource.title}</h3>
        {resource.lead ? (
          <p className="text-sm text-muted-foreground line-clamp-3">{resource.lead}</p>
        ) : null}

        <Link href={href} className="absolute inset-0 flex flex-col items-start p-4">
          <Button variant="default" className="mt-auto" asChild>
            <span>En savoir plus</span>
          </Button>
        </Link>
      </div>
    </div>
  )
}

export { CardResource, type CardResourceProps }
